import React, { Component } from 'react'
import moment from 'moment';

class VisaView extends Component {

    render() {
        let ieInfo = this.props.ieInfo;
        if (!ieInfo) {
            return null;
        }

        return (
            <div>
                {ieInfo.siteUrl && <div className="form-row">
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Адрес сайта</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{ieInfo.siteUrl}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
                <div className="form-row">
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Предполагаемый среднемесячный оборот</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{ieInfo.turnover}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Регистрационный номер</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{ieInfo.registrationNumber}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Дата государственной регистрации</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{moment(ieInfo.dateStateRegistration).format('DD.MM.YYYY')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Наименование регистрирующего органа</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{ieInfo.registeringAuthority}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">УНП</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{ieInfo.payerNumber}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Виды деятельности</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{ieInfo.activities}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {ieInfo.decisionMakersInfo && <div className="form-row">
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Сведения о лицах способных определить решение ИП</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{ieInfo.decisionMakersInfo}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

            </div>
        )
    }
}

export default VisaView
